import { useState } from 'react';

export const usePagination = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const [totVideos, setTotVideos] = useState(0);
	const [startIndex, setStartIndex] = useState(0);
	const itemsPerPage = 15;

	const handlePageChange = newPage => {
		window.scrollTo(0, 0);
		if (newPage <= 0) {
			newPage = 1;
		}
		setCurrentPage(newPage);
		const newStartIndex = (newPage - 1) * itemsPerPage;
		setStartIndex(newStartIndex);
	};

	return {
		currentPage,
		setCurrentPage,
		totVideos,
		setTotVideos,
		startIndex,
		itemsPerPage,
		handlePageChange
	};
};
